import { factory, Flex, Typography, Box, Tab, Link } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './OverlayMenuTabs.module.css.mjs';

const OverlayMenuTabs = factory((props, ref) => {
  const { className, title, CTAs, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Flex, { ref, direction: "column", gap: 10, className: clsx(className, "kohler-overlay-menu-tabs", classes.overlayMenuTabs), ...rest }, title && /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "label-medium-m", textColor: "var(--content-primary)" }, title), /* @__PURE__ */ React.createElement(Flex, { component: "ul", direction: "column", gap: 0 }, CTAs?.map((link) => {
    const { hasChildrenList, ...linkProps } = link;
    return /* @__PURE__ */ React.createElement(Box, { component: "li", key: link.text }, hasChildrenList && /* @__PURE__ */ React.createElement(Tab, { variant: "vertical", id: link.text, textColor: "var(--content-action-default)", type: "button", ...linkProps }), !hasChildrenList && /* @__PURE__ */ React.createElement(
      Link,
      {
        underline: false,
        rightIcon: /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { withBoundingBox: false, size: "xSmall" }),
        className: classes.overlayMenuImageCTA,
        size: "small",
        href: link.href
      },
      link.text
    ));
  })));
});

export { OverlayMenuTabs };
